/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import { Button, DataGrid, IGridColDef, IconButton } from 'src/components';
import { translate } from 'src/i18n/tHelper';
import ThsEimzadokumanDTO from 'src/models/Dokuman/ThsEimzadokumanDTO';
import { EImzaLoginRaporDogrulamaProps } from '.';
import { eImzaLoginSearchHandlerClick, rastgeleVeriUret } from './AramaKriterleri';
import { useEImzaRaporDogrulamaQuery, useLazyEImzaRaporIndirQuery } from 'src/services/Auth/AuthApi';
import { useAppDispatch, useAppSelector } from 'src/store';
import SnackbarUtils from 'src/utils/SnackbarUtils';
import EImzaLoginSlice from 'src/store/slices/Auth/EImzaLoginSlice';

const EImzaLoginRaporDogrulamaListe = (props: EImzaLoginRaporDogrulamaProps): JSX.Element => {
    const eImzaLoginState = useAppSelector(s => s.EImzaLoginState);
    const dispatch = useAppDispatch();
    const state = useEImzaRaporDogrulamaQuery(eImzaLoginState.aramaKriterleri, { skip: eImzaLoginState.aramaKriterleri.belgeKodu ? false : true });
    const [dosyaIndir, dosyaIndirState] = useLazyEImzaRaporIndirQuery();

    const raporKontrolHandlerClick = async (row: ThsEimzadokumanDTO) => {
        if (row.eimzakullaniciId > 0) {
            SnackbarUtils.success(translate("pages|login", "Doğrulama başarılı"));
            await dosyaIndir({ guid: row.guid }).unwrap().then(async (res) => {
                if (!res.content)
                    return;
                let tempLink = document.createElement('a');
                tempLink.href = "data:application/pdf;base64," + res.content;
                tempLink.setAttribute('download', `${res.fileName}`);
                tempLink.click();
                return res.content;
            }).catch(e => e);
            return;
        }
        SnackbarUtils.warning(translate("pages|login", "Belge kodu bulunamadı"));
        dispatch(EImzaLoginSlice.actions.setRastgeleDeger(rastgeleVeriUret()));
    };

    const columns: IGridColDef<ThsEimzadokumanDTO>[] = [
        {
            field: "id",
            headerName: translate("pages|login", "Belge Numarası"),
            width: 120,
            type: "number",
            noThousandSeparator: true
        },
        {
            field: "guid",
            headerName: translate("pages|login", "Belge Kodu"),
            flex: 1,
            minWidth: 290
        },
        {
            field: "raportarih",
            headerName: translate("pages|login", "Belge Tarihi"),
            width: 145,
            type: "dateTime",
            align: "center",
            headerAlign: "center"
        },
        {
            field: "raporKulAdSoyad",
            headerName: translate("pages|login", "E-İmza Kullanıcısı"),
            width: 200
        },
        {
            field: "alandetayId",
            headerName: translate("pages|login", "Numune Kabul No"),
            width: 120,
            type: "number",
            noThousandSeparator: true,
        },
        {
            field: "actions1",
            headerName: translate("pages|login", "Rapor"),
            width: 60,
            renderCell: (params) => {
                return (
                    <IconButton
                        customType="pdf"
                        loading={dosyaIndirState.originalArgs?.guid === params.row?.guid && dosyaIndirState.isFetching}
                        toolTip={translate("pages|login", "Rapor")}
                        onClick={() => { raporKontrolHandlerClick(params.row) }}
                    />
                )
            }
        }
    ];

    useEffect(() => {
        if (!state.isFetching) {
            dispatch(EImzaLoginSlice.actions.setAramaKriterleri({
                ...eImzaLoginState.aramaKriterleri,
                dogrulamaKodu: ""
            }));
        }
    }, [state.isFetching]);

    return (
        <DataGrid
            searchButton={<Button customType="search" loading={state.isFetching} onClick={eImzaLoginSearchHandlerClick}></Button>}
            pinnedColumns={{ right: ["actions1"] }}
            sx={{ height: props.height ? props.height : 600 }}
            loading={state.isFetching}
            rows={!eImzaLoginState.kontrol ? eImzaLoginState?.aramaKriterleri ? state.data ? state.data : [] : [] : []}
            columns={columns}
            initialState={{
                columns: {
                    columnVisibilityModel: {
                        alandetayId: false
                    }
                }
            }}
        />
    )
}

export default EImzaLoginRaporDogrulamaListe;